import { useMount } from 'ahooks';
import React, { useState } from 'react';
import ResponsiveImage from '../../parts/ResponsiveImage';

const fetchProductDetails = (handle) => {
  return fetch(`${window.location.origin}/products/${handle}.json`)
    .then((response) => response.json())
    .then((data) => data);
};

const ProductComparisonCard = (props) => {
  const [product, setProduct] = useState(null);
  const { handle, handleRemoval } = props;

  useMount(() => {
    fetchProductDetails(handle).then((data) => {
      setProduct(data.product);
    });
  });

  if (!product) {
    return null;
  }

  return (
    <div className="Card" data-layout="vertical media-content" data-type="product">
      <figure className="Card__media">
        <ResponsiveImage image={product.image?.src} title={product.title}></ResponsiveImage>
        <button onClick={() => handleRemoval(handle)}>
          <svg viewBox="0 0 20 20" className="icon" width="1em" height="1em">
            <use href="#close"></use>
          </svg>
        </button>
      </figure>
      <div className="Card__details">
        <h4>{product.title}</h4>
      </div>
    </div>
  );
};

export default ProductComparisonCard;
